/** @format */
import { Context, createContext } from 'react';

import { PromoCode } from '@toucan/types/interfaces';

import { QuoteItemRepeaterValue } from '@toucan/components/molecules/quote-item-repeater';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface SellFormErrors {
    sellingItems?: any[];
    buyingItems?: any[];
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface SellFormType {
    sellValues: QuoteItemRepeaterValue[];
    buyValues: QuoteItemRepeaterValue[];
    formErrors: SellFormErrors;
    hasInitialised: boolean;
    scrollToBuyIndex: number;
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface SellFormContextProps {
    sellForm: SellFormType;
    /**
     * Promo code for quote summary / booking in
     */
    promoCode?: PromoCode;
    skuBlacklist: string[];
    setPromoCode: (promoCode?: PromoCode) => void;
    setSellValues: (sellValues: QuoteItemRepeaterValue[]) => void;
    setBuyValues: (
        buyValues: QuoteItemRepeaterValue[],
        callback?: () => void
    ) => void;
    setScrollToBuyIndex: (index: number) => void;
    setFormErrors: (formErrors: SellFormErrors) => void;
    clearSellFormData: () => void;
}

export const SellFormContext: Context<SellFormContextProps> = createContext(
    {} as SellFormContextProps
);

SellFormContext.displayName = 'SellFormContext';
